export const PARTNER_AGENT_LIST_REQUEST = 'PARTNER_AGENT_LIST_REQUEST'
export const PARTNER_AGENT_LIST_SUCCESS = 'PARTNER_AGENT_LIST_SUCCESS'
export const PARTNER_AGENT_LIST_FAIL = 'PARTNER_AGENT_LIST_FAIL'
export const PARTNER_AGENT_LIST_RESET = 'PARTNER_AGENT_LIST_RESET'

export const PARTNER_AGENT_CREATE_REQUEST = 'PARTNER_AGENT_CREATE_REQUEST'
export const PARTNER_AGENT_CREATE_SUCCESS = 'PARTNER_AGENT_CREATE_SUCCESS'
export const PARTNER_AGENT_CREATE_FAIL = 'PARTNER_AGENT_CREATE_FAIL'
export const PARTNER_AGENT_CREATE_RESET = 'PARTNER_AGENT_CREATE_RESET'

export const PARTNER_AGENT_GET_REQUEST = 'PARTNER_AGENT_GET_REQUEST'
export const PARTNER_AGENT_GET_SUCCESS = 'PARTNER_AGENT_GET_SUCCESS'
export const PARTNER_AGENT_GET_FAIL = 'PARTNER_AGENT_GET_FAIL'
export const PARTNER_AGENT_GET_RESET = 'PARTNER_AGENT_GET_RESET'

export const PARTNER_AGENT_UPDATE_REQUEST = 'PARTNER_AGENT_UPDATE_REQUEST'
export const PARTNER_AGENT_UPDATE_SUCCESS = 'PARTNER_AGENT_UPDATE_SUCCESS'
export const PARTNER_AGENT_UPDATE_FAIL = 'PARTNER_AGENT_UPDATE_FAIL'
export const PARTNER_AGENT_UPDATE_RESET = 'PARTNER_AGENT_UPDATE_RESET'

export const PARTNER_AGENT_DELETE_REQUEST = 'PARTNER_AGENT_DELETE_REQUEST'
export const PARTNER_AGENT_DELETE_SUCCESS = 'PARTNER_AGENT_DELETE_SUCCESS'
export const PARTNER_AGENT_DELETE_FAIL = 'PARTNER_AGENT_DELETE_FAIL'

